/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bolt danger': {
    width: 16,
    height: 16,
    viewBox: '0 0 29.3 58.08',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><path pid="0" class="cls-1" d="M16.26 42.29L1.84 55.69l9.47-17.82H1.84l9.5-11.6h-9.5l25.55-23.8L17.8 20h9.58l-9.85 11.94h9.86l-3.72 3.46" id="Layer_1-2" data-name="Layer 1"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/bolt danger.js